import { WorkshopService } from 'api-new/generated';
import { QueryError } from 'features/shared/model';
import { UseMutationOptions, useMutation } from 'react-query';

export const useWorkshopDeleteHoursBookedAvailabilitiesMutation = (
  options?: Omit<
    UseMutationOptions<
      Awaited<ReturnType<typeof WorkshopService.deleteWorkshopHoursBookedAvailabilities>>,
      QueryError,
      number,
      unknown
    >,
    'mutationFn'
  >
) =>
  useMutation((id: number) => WorkshopService.deleteWorkshopHoursBookedAvailabilities(id), {
    ...options
  });
